<div
  class="alert alert-primary"
  i18n="@@memory-required-hint"
>
  Aktiviere die Gedächtnisfunktion unter „Insights“, um diese Funktion nutzen zu können.
</div>